import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Button,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";

const VerifyPortForwardDialog = ({ open, onClose, onConfirm }) => {
  const [fix, setFix] = useState(false);
  const [scanLan, setScanLan] = useState(false);

  const handleClose = () => {
    setFix(false);
    setScanLan(false);
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(fix, scanLan);
    setFix(false);
    setScanLan(false);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Verify Port Forwarding</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Choose which checks to run. Leave both unchecked to just verify
          without making any changes.
        </DialogContentText>
        <FormControlLabel
          control={
            <Checkbox
              checked={fix}
              onChange={(e) => setFix(e.target.checked)}
            />
          }
          label="Fix (apply safe PF repairs)"
        />
        <br />
        <FormControlLabel
          control={
            <Checkbox
              checked={scanLan}
              onChange={(e) => setScanLan(e.target.checked)}
            />
          }
          label="Scan LAN (scan the LAN when configured device IPs are unreachable)"
        />
        {fix && (
          <Alert severity="warning" style={{ marginTop: "12px" }}>
            Fix mode will attempt to apply automatic repairs to this device's
            port forwarding configuration. Do not run this against a live
            customer unit unless you understand the impact — repairs may
            change existing rules.
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Start Verification
        </Button>
        <Button onClick={handleClose} color="primary" variant="outlined">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VerifyPortForwardDialog;
